import { axiosDS } from '@pp/axios'
import {
	OrderCreateParams,
	Region,
	ResponseCatalog,
	OrderModel,
	DadataIpAddress,
	Product,
	InnDataModel,
	LeadCreate,
	PartnerInfo,
	AgreementModel,
	AgreementUploadInfoModel,
	City,
	RequestParams,
	Channel,
	LeadCompleteModel,
} from 'Pages/landings/newLandings/common/types'
import { dadataApiKey, OutLinks, urls } from 'Pages/landings/newLandings/common/constants'
import { CreatePartnerModel } from 'Pages/landings/newLandings/common/types/CreatePartner.model'
import { Lead } from 'Pages/partnerProfile'

export const landingApi = {
	getRegions: async () => {
		const res = await axiosDS().get<ResponseCatalog<Region>>(urls.orders.regions)
		return res.data
	},

	getChannels: async (order_prefix: string) => {
		const res = await axiosDS().get<ResponseCatalog<Channel>>(
			`${urls.orders.channel}?order_prefix=${order_prefix}`
		)
		return res.data
	},

	createOrder: async (params: OrderCreateParams, id?: string) => {
		const res = await axiosDS().post<OrderModel>(`${urls.orders.externalForm}/${id}/order/`, {
			data: params,
		})
		return res.data
	},

	postLeadCreate: async (params: LeadCreate) => {
		const data = new FormData()
		if (params?.file?.length) {
			params.file.forEach((el, index) => {
				let fileName = 'notary_file'
				if (index === 1) {
					fileName += '_second'
				}
				if (index === 2) {
					fileName += '_third'
				}
				// @ts-ignore
				data.append(`data[${fileName}]`, el)
				data.append(`data[${fileName}_name]`, el?.name)
			})
			data.append('data[org_type]', params.org_type)
			data.append('data[parent_id]', params.parent_id.toString())
			data.append('data[parent_type]', params.parent_type)
			data.append('data[bearer]', params.bearer)
			data.append('data[empty_middle_name]', params.empty_middle_name.toString())
			data.append('data[phone]', params.phone)
			data.append('data[inn]', params.inn)
			data.append('data[first_name]', params.first_name)
			data.append('data[timezone]', params.timezone)
			data.append('data[area_name]', params.area_name)
		}
		const res = await axiosDS().post<LeadCreate>(
			urls.landings.leadCreate,
			params?.file ? data : { data: params }
		)
		if (res.status === 201) return res.data
	},

	getPartnerInfo: async (token: string) => {
		const res = await axiosDS().get<PartnerInfo>(`${urls.orders.externalForm}/${token}`)
		return res.data
	},

	getAgreementModel: async () => {
		const res = await axiosDS().get<AgreementModel>(urls.landings.agreementModel)
		return res.data
	},

	getIp: async () => {
		const res = await axiosDS({ isExternal: true }).get<string>(OutLinks.getIp)
		return res.data
	},

	getDadataAddressByIp: async (ip: string) => {
		const urlData = OutLinks.daData.replace(':ip', ip)
		const responseConfig = {
			headers: {
				Authorization: `Token ${dadataApiKey}`,
			},
		}
		const res = await axiosDS({ isExternal: true }).get<DadataIpAddress>(urlData, responseConfig)
		return res.data
	},

	getExternalFormProducts: async (token: string) => {
		const res = await axiosDS().get<Product[]>(
			`${urls.orders.externalForm}/${token}/order/products`
		)
		return res.data
	},

	getCatalogRegionsMqApi: async (requestParams?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<Region>>(urls.orders.regions, {
			params: requestParams,
		})
		return res.data
	},

	sendPostbackExternalForm: async (clickId: string, trackId: string, partnerInn: string) => {
		const postBackUrl = OutLinks.postback[partnerInn]
			.replace(':click_id', clickId)
			.replace(':track_id', trackId)
		return axiosDS().get(postBackUrl)
	},

	getInnRbidosRequestApi: async (data: InnDataModel) => {
		const res = await axiosDS().post<{ inn: string }>(`${urls.cabinet.inn}`, data)
		return res.data
	},

	getAgreementByKeyApi: async (parentType: string, kind: string) => {
		const res = await axiosDS().get<AgreementModel>(
			urls.agreement.byKey.replace(':parent_type', parentType).replace(':kind', kind)
		)
		return res.data
	},

	getAgreementUploadInfoApi: async () => {
		const res = await axiosDS().get<AgreementUploadInfoModel>(urls.agreement.agreementUploadInfo)
		return res.data
	},
	createPartnerApi: async (
		params: CreatePartnerModel & { region_name: string; time_zone: string }
	) => {
		const res = await axiosDS().post<CreatePartnerModel>(urls.landings.createPartner, {
			data: params,
		})
		return res.data
	},
	getCatalogCityApi: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<City>>(urls.landings.getCatalogCity, { params })
		return res.data
	},
	completeLead: async (token: string, params: LeadCompleteModel) => {
		const res = await axiosDS().post<Lead>(`${urls.landings.complete}/${token}`, {
			data: params,
		})
		return res.data
	},
	refreshSmsLead: async (id: string) => {
		const res = await axiosDS().post<string>(`${urls.landings.refresh_sms}/${id}`)
		return res.data
	},
}
